const RequiredAsterisk = () => {
  return <span style={{ color: "red" }}>*</span>;
};

export default RequiredAsterisk;
